import { render, staticRenderFns } from "./NewSoftwareDistribution.vue?vue&type=template&id=c6c773d8&"
import script from "./NewSoftwareDistribution.vue?vue&type=script&lang=js&"
export * from "./NewSoftwareDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports